import GA4 from './GA4'

// eslint-disable-next-line import/prefer-default-export
export const bambuserChannelScript = (channelId, locale, villageSlug) => {
  const localeToDate = {
    en: 'en-GB',
    fr: 'fr-FR',
    es: 'es-ES',
    ca: 'ca-CA',
    it: 'it-IT',
    de: 'de-DE',
    nl: 'nl-NL',
    'pt-BR': 'pt-BR',
    ko: 'ko-KO',
    ar: 'ar-AR',
    ru: 'ru-RU',
  }

  const formattedLocale = localeToDate[locale]

  const isBrowser = () => typeof window !== 'undefined'

  return `
    <div data-bambuser-liveshopping-widget="channel" data-channel-id=${channelId} data-channel-locale="${formattedLocale ||
    ''}" style="padding: 0px 15px 0px 15px; margin: 0px auto; max-width: 1200px"></div>
    <script>
      (function(d, t, i) {
        if (d.getElementById(i)) return;
        var s, ss = d.getElementsByTagName(t)[0];
        s = d.createElement(t); s.id = i;
        s.src = 'https://lcx-widgets-eu.bambuser.com/embed.js';
        ss.parentNode.insertBefore(s, ss);
        
        ${isBrowser() &&
          window.addEventListener(
            'bambuser-liveshop-tracking-point',
            (type) => {
              // @ts-ignore
              if (type?.detail.event === 'on-play') {
                GA4('bambuser_widget_click', {
                  village_name: villageSlug,
                })
              }
            }
          )}
      })(document, 'script', "bambuser-liveshopping-widget");
    </script>
  `
}
